<template>
  <div class="cart-wrap">
    <a href="#" class="cart-trash" @click="removeItemFromCart(item)">
      <svg class="trash" fill="none">
        <use xlink:href="#trash" />
      </svg>
    </a>
    <div class="middle-detail">
      <h5>{{ _T_DB(item, 'name') }}</h5>
      <!--<Modifiers
        v-if="item.modifiers"
        :modifiers="item.modifiers"
        :item="item"
      ></Modifiers>-->
      <div
          :id="'sub_dsc' + item._id"
          class="sub_container"
          v-if="item.combo_selected_items"
      >
        <div class="mt-2"
           v-for="(cmbItm, index) in item.combo_selected_items"
           :key="index"
        >
          <div class="subdescription_container">
            <span class="product_sub_description main-orders-list-item-subtitle color-text-invert item-exclude">
              {{ _T_DB(cmbItm, 'name') }} x {{ cmbItm.quantity || 1 }}
            </span>
          </div>
          <div class="sub_des_catagary mt-1">
            <modifiers v-if="cmbItm.modifiers" :modifiers="cmbItm.modifiers" :item="cmbItm"></modifiers>
          </div>
        </div>
      </div>
      <!--<a
        data-toggle="modal"
        data-target="#customizedModal"
        href="#"
        class="customized-cls"
        @click="showModal()"
      >
        <img src="/images/svg/global/edit.svg" class="img-fluid" alt="" />
        <h6>customized</h6>
      </a>-->
    </div>
    <!--<QtyBox
      :qty="item.quantity || 1"
      :index="item.index"
      :isCart="true"
    ></QtyBox>-->
    <div class="price-right">
      <h5>
        {{ currency }}
        {{Num.price((item.value + combo_item_modifiers_price(item).price) * item.quantity)}}
      </h5>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Modifiers from './Modifiers'
export default {
  name: 'ComboItem',
  props: { item: Object },
  components: {
    Modifiers,
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  computed: {
    ...mapGetters(['_T', '_T_DB', 'hasModifiers', 'combo_item_modifiers_price']),
  },
  methods: {
    ...mapActions(['removeItemFromCart']),
    showModal() {
      this.isModalVisible = true
      this.$store.commit('SELECT_ITEM', this.item)
      this.$store.commit('SET_ITEM_DETAIL_POPUP', this.isModalVisible)
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-wrap {
  padding: 1.875rem 0;
  display: flex;
  align-items: flex-start;
  border-bottom: $px1 solid $light-border;
  .cart-trash {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.25rem;
    background-color: rgba(var(--color-primary-source), 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1.25rem;
  }
  .middle-detail {
    h5 {
      text-transform: capitalize;
      font-weight: 600;
      max-width: $px200;
    }
    .customized-cls {
      display: flex;
      align-items: center;
      h6 {
        line-height: 1.063rem;
        margin-bottom: 0;
        margin-left: 0.313rem;
        text-transform: capitalize;
        color: $warning-color;
      }
    }
  }
  .price-right {
    margin-left: auto;
    h5 {
      text-transform: uppercase;
      margin-bottom: 0;
      font-weight: 600;
    }
  }
}
</style>
